import classNames from 'classnames';
import { FC } from 'react';
import CalendarComponent, { CalendarProps } from 'react-calendar';

import { ReactComponent as ArrowSVG } from 'assets/images/icons/arrow-left.svg';

import { format } from 'date-fns';
import 'react-calendar/dist/Calendar.css';

type PropTypes = CalendarProps & {
  isRange?: boolean;
};

const Calendar: FC<PropTypes> = ({ isRange, ...props }) => {
  return (
    <CalendarComponent
      className={classNames('calendar', {
        calendar__range: isRange,
      })}
      locale="en-GB"
      selectRange={isRange}
      returnValue={isRange ? 'range' : 'start'}
      prevLabel={<ArrowSVG />}
      nextLabel={<ArrowSVG className="calendar__next-arrow" />}
      formatMonth={(locale, date) => format(date, 'MMM')}
      {...props}
    />
  );
};

export default Calendar;
